
import { Vue, Component, Prop } from 'vue-property-decorator';
import CPOptionDropdown from '@/components/open-account/input/CPOptionDropdown.vue';
import { OpenAccountMetadataOption } from '@/store/openAccount/types';

export type OptionAdapter<T> = (item: T) => OpenAccountMetadataOption<any>;

@Component({
  components: { CPOptionDropdown }
})
export default class GenericDropdown<T> extends Vue {
  @Prop({ required: true })
  value!: any; 
  
  @Prop({ required: true })
  options!: T[]; 
  
  @Prop({ required: true })
  adapter!: OptionAdapter<T>;
  
  @Prop({ required: false })
  label?: string;
  
  @Prop({ required: false, default: 'Please Select' })
  placeholder?: string;
  
  @Prop({ required: false, default: false })
  disabled?: boolean;

  get transformedOptions(): OpenAccountMetadataOption<any>[] {
    return this.options.map(this.adapter);
  }

  get transformedValue(): OpenAccountMetadataOption<any> | null {
    const option = this.transformedOptions.find(opt => 
      opt.value === this.value
    );
    return option || null;
  }

  handleInput(option: OpenAccountMetadataOption<any> | null) {
    this.$emit('input', option ? option.value : null);
  }
}
